import { AssignmentJobApi } from '../AssignmentJobApi';
import { Assignment } from '../Assignment';
import { Api } from '@automapa/svelte-automapa-template';
import { type QueriesType } from '../../telematics/types';
import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
import { planning } from '../../../../stores/store';
import { openModal } from 'svelte-modals';
import ModalConfirm from '../../../shared/Modals/ModalConfirm.svelte';

export class DeliveriesBulkActions {
    public static async doAssign(
        api: Api,
        assignmentId: number, // if assignment_id === 0 then it will be unassigned / rejected job
        selectedOrUnselected: number[],
        selectMode: 'filtered' | 'selected' = 'selected',
        subQuery: QueriesType = {},
        selectedDay: string
    ) {
        return AssignmentJobApi.changeAssignments(
            api,
            this.getQuery(
                assignmentId,
                selectedOrUnselected,
                selectMode,
                subQuery,
                null,
                selectedDay
            )
        );
    }

    public static async doReject(
        api: Api,
        selectedOrUnselected: number[],
        selectMode: 'filtered' | 'selected' = 'selected',
        subQuery: QueriesType = {},
        sourceAssignmentId: number|null,
        selectedDay: string
    ) {
        return AssignmentJobApi.changeAssignments(
            api,
            this.getQuery(
                0,
                selectedOrUnselected,
                selectMode,
                subQuery,
                sourceAssignmentId,
                selectedDay
            )
        );
    }

    public static getQuery(
        assignmentId: number,
        selectedOrUnselected: number[],
        selectMode: 'filtered' | 'selected',
        subQuery: QueriesType = {},
        sourceAssignmentId: number | null,
        selectedDay: string
    ): QueriesType {
        let q: QueriesType;
        if (selectMode === 'selected') {
            q = {
                query: { job_id: { $in: selectedOrUnselected } },
            };
        } else if (selectMode === 'filtered') {
            // not tested
            q = {
                query: {
                    ...subQuery,
                    ...{ job_id: { $nin: selectedOrUnselected } },
                    $not: { 'job.rejected_assignments': { $has: assignmentId } },
                    // assignment_id: assignmentId,
                },
            };
        } else {
            throw new Error('Invalid selectMode: ' + selectMode);
        }
        q = {
            ...q,
            assignment_id: assignmentId,
        };
        if (sourceAssignmentId !== null) {
            // if reject we need to know the source assignment
            q = {
                ...q,
                source: sourceAssignmentId,
            };
        }
        // q.query.x_target_date = get(planning).selectedDay;
        q.query.x_target_date = selectedDay;
        return q;
    }

    public static onRouteSelect(
        jobId: number,
        suggestion: boolean,
        newAssignmentId: number | null,
        newAssignment: Assignment | null | undefined
    ): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (newAssignmentId && newAssignment) {
                console.log('onRouteSelect', newAssignment.isLocked());
                if (newAssignment.isLocked()) {
                    let confirm: { title: string; message: string };
                    if (newAssignment.isDownloaded()) {
                        confirm = {
                            title: get(_)('route_already_downloaded'),
                            message: get(_)('new_jobs_will_be_added_on_commit_subject_to_approval'),
                        };
                    } else {
                        confirm = {
                            title: get(_)('route_already_locked'),
                            message: get(_)('adding_jobs_unlocks_route'),
                        };
                    }
                    console.log('onRouteSelect', confirm.title, confirm.message);
                    openModal(ModalConfirm, {
                        title: confirm.title,
                        text: confirm.message,
                        onClick: async () => {
                            resolve(true);
                        },
                        onCancel: () => {
                            resolve(false);
                        },
                    });
                    return;
                } else {
                    resolve(true);
                }
            } else {
                console.error('onRouteSelect', 'newAssignmentId or newAssignment is null');
                resolve(false);
            }
        });
    }
}
